(function(){
'use strict';

/*
 * scSsoService
 *
 * */

scSsoService.$inject = ["$http", "$log", "$rootScope", "$q", "scMembersService", "scCampaignsService", "scFundraisingPagesService", "scFundraisingTeamsService", "scOrganizationsService", "$window"];
function scSsoService($http, $log, $rootScope, $q, scMembersService, scCampaignsService, scFundraisingPagesService, scFundraisingTeamsService, scOrganizationsService, $window) {
  var _this = this;

  this.initMember = function (member) {
    var deferred = $q.defer();
    scMembersService.init(member);
    scMembersService.you.update(member);
    scFundraisingPagesService.userFundraisers = {};

    if (_.get(scCampaignsService, 'active.current', false) && scCampaignsService.active.HAS_FUNDRAISING) {
      scMembersService.getAllMemberPages(member.id, scCampaignsService.active.current.id).then(function (resp) {
        _.forEach(resp.fundraisingPages, function (page) {
          scFundraisingPagesService.add(page);

          // add the team associated with the fundraising page
          if (page.fundraising_team_id) {
            scFundraisingTeamsService.fetch(page.fundraising_team_id);
          }
        });

        // getAllMemberPages only grabs teams that the member is a team lead for (aka created the team)
        _.forEach(resp.fundraisingTeams, function (team) {
          scFundraisingTeamsService.add(team);
        });

        deferred.resolve();
      }).catch(function () {
        deferred.resolve();
      });
    }
    return deferred.promise;
  };

  this.stealthLogin = function () {
    var orgId = _.get(scOrganizationsService, 'active.current.id', false);
    var campaignId = _.get(scCampaignsService, 'active.current.id', false);

    var div = angular.element('\n      <div style="width:1px; height:1px; opacity:0; overflow:hidden;">\n        <div\n          class="classy-login-iframe"\n          data-flow="login_only"\n          data-org_id="' + orgId + '"\n          data-campaign_id="' + campaignId + '"></div>\n      </div>');
    var deferred = $q.defer();

    div.appendTo('body');
    Classy.ready(function () {
      Classy.parseDom(function (response) {
        div.remove();
        if (response.authorization_code) {
          var xhrFields = {};
          if (SC.env === 'development') {
            xhrFields = {
              xhrFields: {
                withCredentials: true
              }
            };
          }
          $http(Object.assign({
            method: 'GET',
            url: '/oauth2/iframe_callback?code=' + response.authorization_code
          }, xhrFields)).then(function (oAuthResponse) {
            $log.log('SSO success');
            /* Exclude Members from Adroll Segmenting */
            try {
              __adroll.record_user({
                adroll_segments: 'member'
              });
            } catch (err) {}

            if (oAuthResponse.data.member) {
              _this.initMember(oAuthResponse.data.member).then(function () {
                deferred.resolve();
              });
            } else {
              deferred.resolve();
            }
          }).catch(function () {
            deferred.resolve();
          });
        } else if (response.idp_url) {
          // IDP Login
          $window.top.location.assign(response.idp_url);
        } else {
          // handle error.
          $log.log('SSO failed: ' + response.error);
          $rootScope.SC.status.banner = {
            type: 'error',
            msg: "I'm sorry, there was a problem signing you in."
          };
          deferred.reject();
        }
      });
    });
    return deferred.promise;
  };
}

angular.module('classy').service('scSsoService', scSsoService);
})();